<div class="close-container">
  <span>

    <button mat-icon-button mat-dialog-close class="close-button" aria-label="Cerrar" (click)="cerrarModal()">
      <mat-icon style="cursor: pointer; display: flex;
    justify-content: center;">close</mat-icon>
    </button>
  </span>
</div>
<div class="modal-container">

  <div mat-dialog-content>
    <h2 mat-dialog-title class="text-center modal-title">Código de Verificación</h2>
    <p class="text-center modal-description">
      Hemos enviado un código de verificación a tu correo electrónico
      <strong>{{ getFormattedEmail(data.use_email) }}</strong>
    </p>
    <p class="text-center modal-description">Por favor, ingresa el código a continuación para continuar.</p>

    <div class="verification-code-container">
      <form [formGroup]="validationForm" (ngSubmit)="verificarCodigo()">
        <div class="code-inputs">
          <input *ngFor="let control of codigoInputs; let i = index" [formControlName]="'codigo' + i"
            (input)="onInput($event, i)" (keydown)="onKeyDown($event, i)" (paste)="onPaste($event)" type="text"
            maxlength="1" class="code-input" aria-label="Código de verificación" />

        </div>
      </form>
    </div>



    <p class="text-center mt-2 modal-detail">
      ¿No recibiste el código?
      <a (click)="reenviarCodigo()" class="resend-link modal-detail" style="color: blue; cursor: pointer; "
        [ngStyle]="{ 'color': isResendDisabled ? 'black' : 'blue', 'cursor': isResendDisabled ? 'not-allowed' : 'pointer' }">Haz
        click aquí para recibir un nuevo código.</a>
    </p>
    <div class="countdown-timer text-center" *ngIf="isResendDisabled">
      <p class="timer-text">
        Podrás solicitar un nuevo código en <strong>{{ formattedTime }}</strong>
      </p>
    </div>
  </div>

  <div mat-dialog-actions align="center">
    <button mat-raised-button class="boton-validar" color="primary" [disabled]="!validationForm.valid"
      (click)="verificarCodigo()">
      Verificar Código
    </button>
  </div>
</div>